import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { PlanoAcaoService } from "../services/plano-acao.service";

@Injectable({
  providedIn: 'root'
})
export class PlanoAcaoResolver implements Resolve<boolean> {

  constructor(private service: PlanoAcaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PlanoAcaoSimplificadoResolver implements Resolve<boolean> {

  constructor(private service: PlanoAcaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdSimple(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PlanoAcaoListResolver implements Resolve<boolean> {

  constructor(private service: PlanoAcaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdList();
  }
}